import { ProductivityRequester, type ProductivitySummaryRequest, type ProductivityTimeSeriesChartRequest, type TimeseriesChart } from '@cobliteam/api-lib';

import type { ProductivitySummary } from '@cobliteam/common-types';
import { Environment } from '@cobliteam/react-environments';
import { useQuery } from '@tanstack/react-query';

const env = Environment.getInstance().getEnvironment();

// Lazy instantiation to avoid circular dependency issues
const getProductivityRequester = () => new ProductivityRequester({ host: env.apiHost });
const DRIVER_QUERY_KEY = 'DRIVER_PRODUCTIVITY';
const VEHICLE_QUERY_KEY = 'VEHICLE_PRODUCTIVITY';
const PRODUCTIVITY_CHART_QUERY_KEY = 'PRODUCTIVITY_CHART';

const useProductivity = () => {
  const getVehicleProductivitySummary = (request: ProductivitySummaryRequest) =>
    useQuery<ProductivitySummary>({
      queryKey: [`${VEHICLE_QUERY_KEY}_SUMMARY`, JSON.stringify(request)],
      queryFn: () => getProductivityRequester().getVehicleProductivitySummary(request),
      staleTime: 300000,
    });

  const getDriverProductivitySummary = (request: ProductivitySummaryRequest) =>
    useQuery<ProductivitySummary>({
      queryKey: [`${DRIVER_QUERY_KEY}_SUMMARY`, JSON.stringify(request)],
      queryFn: () => getProductivityRequester().getDriverProductivitySummary(request),
      staleTime: 300000,
    });

  const getTimeSeriesChart = (request: ProductivityTimeSeriesChartRequest, enabled = true) =>
    useQuery<TimeseriesChart[]>({
      queryKey: [PRODUCTIVITY_CHART_QUERY_KEY, JSON.stringify(request)],
      queryFn: () => getProductivityRequester().getProductivityTimeSeriesChart(request),
      retry: false,
      enabled: enabled,
    });

  return {
    getVehicleProductivitySummary,
    getDriverProductivitySummary,
    getTimeSeriesChart,
  };
};
export default useProductivity;
